import axios from 'axios';
import qs from 'qs';

import { refreshTokenOttWeb } from './refreshtoken';
import { getKeycloakToken } from './tokenStorage';

export const logoutKeycloak = async () => {
  try {
    const localKeycloak = getKeycloakToken();
    const newKeycloak = await refreshTokenOttWeb(localKeycloak);
    localStorage.clear()

    const body = {
      'client_id': process.env.REACT_APP_KC_CLIENT_ID,
      'refresh_token': newKeycloak.refreshToken,
      'session_state': newKeycloak.sessionState
    };

    const headers = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      timeout: 10000
    };

    await axios.post(
      `${process.env.REACT_APP_KC_URL}realms/megamedia/protocol/openid-connect/logout`,
      qs.stringify(body),
      headers
    )
  } catch (error) {
    console.log(`Ocurrió un problema al intentar cerrar la sesión de Keycloak`, error);
    throw Error(error.message)
  }
};